import css from 'styled-jsx/css'

import { sizes } from '../../theme'


export default css`
  .projects :global(.swiper) {
    text-align: right;
  }

  .projects :global(.swiper .swiper-button-disabled) {
    opacity: .3;
    pointer-events: none;
  }

  .projects :global(.button-prev),
  .projects :global(.button-next) {
    background: transparent;
    cursor: pointer;
    transition: opacity .3s ease;
  }

  .projects :global(.button-prev img),
  .projects :global(.button-next img) {
    margin-top: 3rem;
    width: 4rem;
  }

  .projects :global(.button-prev) {
    margin-right: 3rem;
  }

  @media (max-width: ${sizes.media.tablet.maxWidth}) {
    .projects :global(.button-prev img),
    .projects :global(.button-next img) {
      display: none;
    }

    .projects {
      margin-right: -3rem;
    }
  }
`
